import React from "react";
import { useDispatch } from "react-redux";
import AuthActions from "@/store/ducks/auth";
import { Page, DashboardContainer } from "@/components/Grid";
import { FranqueadoMenu } from "@/components/Franqueados";
import { Navbar } from "@/components/Blocks";
import { FranqueadosProvider } from "@/context/franqueados";
import ContaBancaria from "@/components/Franqueados/ContaBancaria";

import { Header } from "./styles";

function ContaBancariaPage({ history }) {
  const dispatch = useDispatch();

  return (
    <Page>
      <Navbar type="interna" />
      <FranqueadoMenu />
      <DashboardContainer>
        <Header>
          <h4>Minha Conta</h4>
          <h2>Conta Bancária</h2>
          <div className="breadcrumbs">
            Conta <span>{">"} Conta Bancária</span>
          </div>
        </Header>
        <ContaBancaria />
      </DashboardContainer>
    </Page>
  );
}

export default function ContaBancariaPageWrapper(props) {
  return (
    <FranqueadosProvider>
      <ContaBancariaPage {...props} />
    </FranqueadosProvider>
  );
}
